import React from 'react';
import './NoMatch.scss';
//import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
export default function NoMatch() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="error-template">
            <h1>Oops!</h1>
            <h2>404 Not Found</h2>
            <div className="error-details">
              Sorry, an error has occured, Requested page not found!
            </div>
            <div className="error-actions">
              <Link to={'/'} className="btn btn-primary btn-lg">
                <React.Fragment>
                  <span className="glyphicon glyphicon-home" /> Take Me Home
                </React.Fragment>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
